export const WORK_STATUS = {
  FULL_TIME: 'FULL_TIME',
  PART_TIME: 'PART_TIME',
  SELF_EMPLOYED: 'SELF_EMPLOYED',
  CASUAL: 'CASUAL',
  UNEMPLOYED: 'UNEMPLOYED',
  STUDENT: 'STUDENT',
  STAY_HOME_PARENT: 'STAY_HOME_PARENT',
  RETIRED: 'RETIRED',
};

export const workStatuses = [
  {
    type: WORK_STATUS.FULL_TIME, title: 'work_status.full_time', areDetailsNeeded: true, intl: true,
  },
  {
    type: WORK_STATUS.PART_TIME, title: 'work_status.part_time', areDetailsNeeded: true, intl: true,
  },
  {
    type: WORK_STATUS.SELF_EMPLOYED, title: 'work_status.self_employed', areDetailsNeeded: true, intl: true,
  },
  { type: WORK_STATUS.CASUAL, title: 'work_status.casual', areDetailsNeeded: true, intl: true },
  { type: WORK_STATUS.UNEMPLOYED, title: 'work_status.unemployed', intl: true },
  { type: WORK_STATUS.STUDENT, title: 'work_status.student', intl: true },
  { type: WORK_STATUS.STAY_HOME_PARENT, title: 'work_status.stay_home_parent', intl: true },
  { type: WORK_STATUS.RETIRED, title: 'work_status.retired', intl: true },
];
